import React, { useState, useEffect } from 'react'
import { Autocomplete, TextField, Checkbox, Box } from '@mui/material'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

const icon = (
  <CheckBoxOutlineBlankIcon
    fontSize="small"
    sx={{
      color: '#d500f9',
    }}
  />
)

const ListDropdown = ({ options, onApply, clear, value }) => {
  const [selectedValue, setSelectedValue] = useState(
    options?.filter((it) => value?.includes(it.value)) || []
  )

  useEffect(() => {
    if (clear) {
      setSelectedValue([])
    }
  }, [clear])

  const sortedOptions = [...options].sort((a, b) => {
    if (a.value < b.value) return -1
    if (a.value > b.value) return 1
    return 0
  })

  const handleChange = (event, newValue) => {
    const uniqueValues = newValue.filter(
      (option, index, self) => self.findIndex((o) => o.value == option.value) == index
    )
    setSelectedValue(uniqueValues)
    onApply(uniqueValues)
  }

  const getSelectedCount = (option) => {
    const foundOption = options.find((o) => o.value == option.value)
    return foundOption ? foundOption.count : 0
  }

  return (
    <Box display="flex" flexDirection="column">
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        options={sortedOptions}
        disableCloseOnSelect
        getOptionLabel={(option) => `${option.value} (${getSelectedCount(option)})`}
        value={selectedValue}
        onChange={handleChange}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props
          const isSelected = selectedValue.some((sel) => sel.value === option.value)

          return (
            <li
              key={key}
              {...optionProps}
              style={{
                margin: '0px',
                padding: '0px',
                listStyle: 'none',
                marginBottom: '5px',
                fontSize: '10px',
                lineHeight: '1.2',
              }}
            >
              <Checkbox
                icon={icon}
                color="primary"
                checked={isSelected}
                sx={{
                  '& .MuiSvgIcon-root': {
                    color: selected ? 'primary' : 'success',
                    fontSize: '14px',
                  },
                }}
              />
              {`${option.value} (${getSelectedCount(option)})`}
            </li>
          )
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select"
            placeholder="Select"
            sx={{
              '& .MuiAutocomplete-inputRoot': {
                paddingRight: '0px !important',
                paddingLeft: '0px !important',
              },
              '& .MuiOutlinedInput-root': {
                paddingRight: '0px !important',
                paddingLeft: '0px !important',
              },
              '& .MuiAutocomplete-endAdornment': {
                display: 'none',
              },
              '& .MuiInputBase-root': {
                height: selectedValue.length == 0 ? '37px' : 'auto',
              },
              '& .MuiInputLabel-root': {
                top: '-6px',
              },
            }}
          />
        )}
        disableClearable
        ChipProps={{
          size: 'small',
          style: {
            fontSize: '12px',
            padding: '0px',
            height: '20px',
          },
        }}
      />
    </Box>
  )
}

export default ListDropdown
